<script>
import BarList from "../components/bar-list";
import BarGrid from "../components/bar-grid";
import FilterList from "../components/filter-list";
import {
  apiORDS,
  apiORDSpost
} from "../shared/api-functions";
import { getText, formatDataHoraExtenso } from "../shared/utils";
import { SysVars } from "../main";
import ControlecaixaForm from "./varejo-controlecaixa-form";
import VarejoEmissaoCupom from "./varejo-emissao-cupom";

export default {
  components: {
    BarList,
    BarGrid,
    ControlecaixaForm,
    VarejoEmissaoCupom
  },

  props: {
    params_pdv: {
      type: Object,
      default: () => ({ colors: {} })
    }
  },

  data() {
    return {
      showForm: false,
      showCupom: false,
      codvabertura: null,
      filter: "",
      monthQuery: "",
      textQuery: "",
      statusQuery: "",
      filterList: [],
      paramFilterList: {},
      metadata: this.$store.getters.getEntities.metadata,

      SHOW_CONFIRMADMINPASS: false,
      params_confirmAdminPass: "",

      vaberturaList: [],
      vaberturaList: [],

      filtroStatus: {
        list: [
          { id: 0, label: "Todos" },
          { id: 1, label: "Em Aberto" },
          { id: 2, label: "Fechados" },
          { id: 3, label: "Conferidos" }
        ],
        index: 0
      },

      query: {
        codusuario: null,
        codequipe: null,
        text: null,
        after: null,
        before: null,
        codstatus: null
      }
    };
  },

  computed: {
    labelStatus: function () {
      return this.filtroStatus.list[this.filtroStatus.index].label;
    }
  },

  methods: {
    confirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
      this.params_confirmAdminPass();
    },
    showConfirmAdminPass(params) {
      this.SHOW_CONFIRMADMINPASS = true;
      this.params_confirmAdminPass = params;
    },
    hideConfirmAdminPass() {
      this.SHOW_CONFIRMADMINPASS = false;
    },

    handleChangeUser(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showConfirmAdminPass(this.handlerUpdateUser);
    },

    async handlerUpdateUser() {
      if (this.codvabertura) {
        let sendData = {
          caixa: {
            id: this.codvabertura
          }
        }
        const data = await apiORDSpost(this.$store, 'varejo/controlecaixa/' + this.codvabertura + '/operador', sendData, 'post')
        this.loadData()
        if (data.errmessages) {
          this.$erpToastError('Erro erro ao mudar operador do caixa')
          this.errmessages = data.errmessages
        }
        else
          this.$erpToastSuccess('Caixa atualizado')


      }

    },


    handleShowForm(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showForm = true;
    },

    handleShowCupom(caixa) {
      this.codvabertura = caixa.codvabertura;
      this.showCupom = true;
    },

    handleResultadoEmissaoCupomFechamento() {
      this.showCupom = false
    },

    handleChangeFiltroStatus(obj) {
      this.filtroStatus.index = obj.id;
      this.loadData();
    },

    statusColor: function (stpedv, tppedv) {
      let color = "badge-green";
      if (stpedv == "C" || stpedv == "R" || tppedv == "R") {
        color = "badge-red";
      } else if (stpedv == "F") {
        color = "badge-blue";
      } else if (tppedv == "O") {
        color = "badge-orange";
      } else if (tppedv == "P") {
        color = "badge-green";
      }
      return color;
    },

    closeForm() {
      this.showForm = false;
      this.$scrollTo(0);
      this.loadData();
    },

    changeFiltroTexto(value) {
      //efetua a pesquisa por texto
      this.query.text = value.toUpperCase();
      this.query.after = null;
      this.query.before = null;
      this.loadData();
    },

    horaStatus(hora) {
      return formatDataHoraExtenso(hora);
    },

    changeFiltroMes(filter, startDate, endDate) {
      this.query.after = startDate;
      this.query.before = endDate;
      this.query.text = null;
      this.loadData();
    },

    async loadData() {
      let param = {};
      param.query = "";

      // if (this.query.text)
      //   param.query = param.query + 'text=' + this.query.text + '&'
      // if (this.query.after)
      //   param.query = param.query + 'after=' + this.query.after + '&'
      // if (this.query.before)
      //   param.query = param.query + 'before=' + this.query.before + '&'
      // if (this.query.codstatus)
      //   param.query = param.query + 'codstatus=' + this.query.codstatus + '&'

      param.query = null;
      if (this.filtroStatus.index)
        if (this.filtroStatus.index == 1) param.query = "status=aberto";
        else if (this.filtroStatus.index == 2) param.query = "status=fechado";
        else if (this.filtroStatus.index == 3) param.query = "status=conferido";

      const data = await apiORDS(
        this.$store.getters.urlOrds + "varejo/controlecaixa/list",
        param
      );
      if (data.items) this.vaberturaList = data.items;
    },

  },

  created() {
    if (this.$route.params.id) {
      this.showForm = true;
      this.codvabertura = this.$route.params.id;
    }
    this.loadData();
  }
};
</script>

<template>
  <div>
    <div id="list" v-show="!showForm">
      <bar-list :refresh-button="true" :new-button="false" :pdf-button="false" :xls-button="false" :filter-month="true"
        plural-entity="Controle de Caixas" @search="changeFiltroTexto" @refresh="loadData" @filter="changeFiltroMes"
        title-search="Pesquise pelo nome do operador">
      </bar-list>
      <div class="row align-items-center mb-3">
        <div class="col-12">
          <span class="lbl">Status
            <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown">
              {{ labelStatus }} <span class="caret"></span></a>
            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <a class="dropdown-item" href="javascript:void(0)" v-for="(filtro, index) in filtroStatus.list"
                :key="index" @click="handleChangeFiltroStatus(filtro)">{{ filtro.label }}</a>
            </div>
          </span>
        </div>
      </div>

      <div class="default-container p-0">
        <alert v-if="vaberturaList.length == 0" type="warning" text="Nenhum registro foi encontrado."></alert>
        <div class="w-100" style="margin: 5px 0 5px; border-bottom: 1px solid #eee;"
          v-for="(item, index) in vaberturaList" :key="index">
          <div class="row p-3">
            <div class="col-md-2">
              <span class="lbl-list"> Data </span><br />
              <span class="data-list"> {{ item.data | formatDataHora }}</span>
            </div>
            <div class="col-md-2">
              <span class="lbl-list">Caixa</span><br />
              <span class="data-list"> {{ item.caixa }}</span>
            </div>
            <div class="col-md-2">
              <span class="lbl-list"> Operador </span><br />
              <span class="data-list"> {{ item.operador }}</span>
            </div>
            <div class="col-md-2">
              <span class="lbl-list"> Valor em Vendas </span><br />
              <span class="data-list">
                {{ item.totalvendas | formatValue(2, true) }}</span>
            </div>
            <div class="col-md-1">
              <span v-if="item && item.aberto" class="badge badge-green ml-2" data-toggle="tooltip" data-placement="top"
                title="">{{ item.status }}
              </span>
              <span v-if="item.conferido" class="badge badge-green ml-2" data-toggle="tooltip" data-placement="top"
                title="">{{ item.status }}
              </span>
              <span v-if="!item.conferido && !item.aberto" class="badge badge-gray ml-2" data-toggle="tooltip"
                data-placement="top" title="">{{ item.status }}
              </span>
            </div>
            <!-- <div class="col-md-1">
              <span class="lbl-list"> Filial </span>
              <span class="data-list"> {{ item.filial }}</span>
            </div> -->
            <div class="col-auto text-right">
              <v-button v-if="item.aberto" class="float-right" icon="" label="Fechar Caixa"
                @click="handleShowForm(item)"></v-button>

              <v-button v-if="item.aberto" class="float-right" icon="fa-user" title="Trocar Usuario"
                @click="handleChangeUser(item)"></v-button>

              <v-button v-if="!item.aberto" class="float-right" icon="fa-search" title="" @click="handleShowForm(item)">
              </v-button>
              <v-button v-if="!item.aberto" class="float-right" icon="fa-print" title="" @click="handleShowCupom(item)">
              </v-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <controlecaixa-form v-if="showForm" :index="this.codvabertura" @closeform="closeForm"></controlecaixa-form>

    <transition name="fade">
      <VarejoEmissaoCupom v-if="showCupom" :index="this.codvabertura" tipo="fechamentocaixa"
        @resultadoemissaocupom="handleResultadoEmissaoCupomFechamento">
      </VarejoEmissaoCupom>
    </transition>

    <!--Modal Senha de Confirmarção-->
    <confirm-adminpass v-if="SHOW_CONFIRMADMINPASS" @close="hideConfirmAdminPass()" @confirm="confirmAdminPass()" />



  </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-controlecaixa-list.vue